import { useEffect } from "react";

// Unsaved-changes guard for the tour editor. The app uses a declarative
// <BrowserRouter> (not a data router), so react-router's useBlocker is
// unavailable — we can't intercept SPA navigation through it. Instead each
// editor section reports its dirty state to this module-level flag, and the two
// exit paths are guarded manually:
//   • browser reload / tab close  → beforeunload (this hook)
//   • sidebar navigation in editor → AppSidebar reads isEditorDirty() on click
// ponytail: module-level flag (not context) — only one editor section is
// mounted at a time, so a single boolean is enough; lift to context if a second
// concurrent dirty surface ever appears.
let dirty = false;

export function isEditorDirty(): boolean {
  return dirty;
}

export function clearEditorDirty(): void {
  dirty = false;
}

/** Registers the current section's dirty state + a browser reload/close guard. */
export function useUnsavedGuard(isDirty: boolean): void {
  useEffect(() => {
    dirty = isDirty;
    if (!isDirty) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      dirty = false;
    };
  }, [isDirty]);
}
